import styled from "styled-components"
import Slider from "react-slick"
import Image from "next/image"

export const StyledSliderImage = styled(Image)`
  width: 100%;
  height: auto;
  margin: auto;
  cursor: pointer;
}
`
export const ProductSlider = styled(Slider)`
  > .slick-dots li button:before {
    font-size: 12px;
    text-align: center;
    cursor: pointer;
  }
`

export const ProductImageSlider = styled(Slider)`
  > .slick-dots li button:before {
    font-size: 12px;
    text-align: center;
  }
`

export const StyledImageSliderImage = styled.img`
  max-width: 100%;
  max-height: 100px;
  border-radius: 5px;
  padding: 4px;
  cursor: pointer;
  }
`

export const ProductSliderWrapper = styled(Slider)`
  & * > .slick-slide {
    height: auto !important;
  }
  & * > .slick-slide > div {
    margin: 0 16px 0 8px !important;
  }
  & > .slick-list {
    padding: 1rem 0 0.5rem 0 !important;
  }
  @media (max-width: 601px) {
    & > .slick-prev, .slick-next {
      display: none !important;
    }
  }
  & > .slick-prev, .slick-next {
    cursor: pointer;
  }
  & > .slick-prev::before, .slick-next::before {
    content: none;
  }
`
